<template>
    <div class="col-sm-12 nopads">
        <div class="search-form">
            <div class="col-sm-12 search-form-title" style="margin-left: .75em">
                <font-awesome-icon icon="search"/>
                {{ $t('common.search') }}
            </div>
            <form
                id="material-report-search"
                class="mt-2 p-2"
                @submit.prevent="onSubmit"
                @reset="onReset"
            >
                <div class="row p-2">
                    <div class="col-sm-6 nopads  pl-1 pr-1">
                        <span class="span-title">{{ $t('trip_list.road_sec_from') }} - {{ $t('daily_summary.date') }}</span>
                        <input
                            id="fromDate"
                            v-model="fromDate"
                            type="date"
                            class="form-control form-control-sm"
                            :class="{ 'is-valid': fromDate !== null }"
                        />
                    </div>
                    <div class="col-sm-6 nopads pl-2 pr-1">
                        <span class="span-title">{{ $t('trip_list.road_sec_to') }} - {{ $t('daily_summary.date') }}</span>
                        <input
                            id="date"
                            v-model="toDate"
                            type="date"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="row p-2">
                    <div class="col-sm-4" style="margin-top: -.35em">
                        <open-contract-filter-multi-select
                            :to="toDate"
                            :from="fromDate"
                            :show-company="false"
                            :no-pads="true"
                            :show-only-my-contracts-option="true"
                            :required="true"
                            @loading="loading++"
                            @loadingCompleted="loading--"
                            @contractsSelected="setContracts"
                        />
                    </div>
                    <div class="col-sm-4"  style="margin-top: -.4em">
                        <contract-order-multiselect
                            @ordersSelected="setOrders"
                            :contractIds="contractIds"
                            :show-info="true"
                            :show-executor-text="true"
                        />
                    </div>
                    <!-- User -->
                    <div class="col-sm-4 pl-2" style="margin-top: -.4em">
                        <span class="span-title">{{ $t('trip_list.search_with_username') }}</span>
                        <multiselect
                            v-model="userParam"
                            class="multiselect_routa"
                            :placeholder="$t('work_time.select_person')"
                            :deselect-label="$t('common.remove_selection')"
                            :select-label="$t('common.select')"
                            :close-on-select="false"
                            :multiple="true"
                            label="name"
                            track-by="name"
                            :searchable="true"
                            :internal-search="true"
                            :selected-label="$t('common.selected')"
                            :options="userOptions"
                            :disabled="contractIds.length < 1"
                        >
                            <template
                                #singleLabel="props"
                            >
                        <span class="option__desc">
                          <span class="option__title">{{ props.option.name }}</span>
                        </span>
                            </template>
                            <template
                                #option="props"
                            >
                                <div class="option__desc">
                                    <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
                                </div>
                            </template>
                            <span slot="noResult">{{ $t('common.not_found') }}</span>
                            <span slot="noOptions">{{ $t('common.no_results') }}</span>
                        </multiselect>
                    </div>
                </div>
                <div class="col-sm-12 button-container">
                    <button
                        type="reset"
                        class="btn btn-sm btn-danger form-button"
                    >
                        {{ $t('delivery_note.clear') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-sm btn-primary form-button"
                    >
                        {{ $t('common.search') }}
                    </button>
                </div>
            </form>
        </div>
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import {orderMixin} from "@/components/mixins/OrderMixin";
import ContractOrderMultiselect from "@/components/order/ContractOrderMultiselect.vue";
import OpenContractFilterMultiSelect from "@/components/contract/OpenContractFilterMultiSelect.vue";

export default {
    name: "MaterialReportSearch",
    components: {OpenContractFilterMultiSelect, ContractOrderMultiselect},
    mixins: [restApi, timeUtils, orderMixin],
    data: function () {
        return {
            fromDate: this.loginTime ? this.loginTime.toISOString() : null,
            toDate: null,
            contractIds: [],
            orders: [],
            loading: 0,
            userOptions: [],
            userParam: null,
            onlyUserOwnedContracts: 0
        }
    },
    props: {
        loginTime: {
            type: Date,
            default: null
        },
        materials: {
            type: Array,
            default() {
                return []
            }
        },
        showOnlyMyContractsOption: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        onlyUserOwnedContracts: function() {
            this.$emit('onlyUserOwnedContractSelected', this.onlyUserOwnedContracts, "search")
        },
    },
    mounted() {
        if (!this.fromDate) {
            this.fromDate = this.getDateAsString(this.getMonthStartAsDate())
        }
        this.fetchUsers()
    },
    methods: {

        fetchUsers: function () {
            this.loading++
            this.restFetch(this.userUrl, this.handleUsers)
        },
        handleUsers: function (response) {
            if (response && response.data) {
                this.userOptions = response.data.map(function (user) {
                    return {value: user.id, name: user.last_name + ', ' + user.first_name}
                })
            }
            this.loading--
        },

        setContracts(contracts) {
            this.contractIds = []
            contracts.map(contract => {
                this.contractIds.push(contract.id)
            })
        },

        setOrders: function (orders) {
            this.orders = orders
        },

        refreshParams: function() {
            this.onSubmit()
        },

        onSubmit: function () {
            let params = {}
            if (this.fromDate !== null) {
                params.from = this.fromDate
            } else {
                this.showAlert(this.$t('weighing_notes.form_validation.select_date_from'))
                return;
            }
            if (this.toDate !== null) {
                params.to = this.toDate
            } else {
                params.to = (new Date()).toISOString()
            }
            // enable searching only when contract selected
            if(this.contractIds && this.contractIds.length > 0) {
                params.contractIds = this.contractIds
                if(this.orders && this.orders.length > 0) {
                    params.orders = this.orders.map(order => order.id)
                }
                if (this.userParam && this.userParam.length > 0) {
                    params.users = this.userParam.map(user => user.value)
                }
            }
            this.$emit('search', params)
        },
        onReset: function () {
            this.orders = []
            this.contractIds = []
            this.fromDate = null
            this.toDate = null
            this.userParam = null
            this.onlyUserOwnedContracts = 0
        },
    }
}
</script>
